import { Grid, Typography, Box, useMediaQuery } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { getFeeds, getYoutubeVideoURL } from '../../Utils/apiService';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import KenColors from '../../Helpers/Themes/kenColors';
interface MediaItem {
  url: string;
  type: string;
}
interface FeedItem {
  userImage: string;
  title: string;
  date: string;
  mediaLogo: string;
  content: string;
  hashtags: string;
  media: MediaItem[];
}

// Utility function to linkify URLs in text
function linkify(text: string) {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.replace(urlRegex, (url) => {
    return `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color:#1976d2;text-decoration:underline;">${url}</a>`;
  });
}

type FeedProps = {
  containerHeight?: string;
};

const Feed: React.FC<FeedProps> = ({ containerHeight }) => {
  const { state: { user } } = useContext(AuthContext);
  const userData = user as any;
  const [feedData, setFeedData] = useState<FeedItem[]>([]);
  const isMobile = useMediaQuery('(max-width:900px)');
  const is1440 = useMediaQuery('(min-width:1440px)');
  const [youtubeVideoURL, setYoutubeVideoURL] = useState<any>(null);
  const resolvedHeight = containerHeight ?? (isMobile ? "100%" : "calc(100vh - 143px)");
  useEffect(() => {
    getYoutubeVideoURL().then((res) => {
      console.log(res, "resresresresres");
      setYoutubeVideoURL(res?.data?.records?.[0]);
    });
    getFeeds().then((res) => {
      const apiData = res?.data?.x || [];
      // console.log(apiData, "apiDataapiDataapiDataapiData");

      const formattedData = apiData.map((item: any) => {
        const date = new Date(item.created_at.split(" ")[0]);
        const formattedDate = date.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
        }).replace(/ /g, ' ');
        const hashtags = (item.text.match(/#[\w]+/g) || []).join(' ');
        return {
          userImage: item?.user?.pfp_url ? item?.user?.pfp_url : "https://images.crunchbase.com/image/upload/c_pad,h_256,w_256,f_auto,q_auto:eco,dpr_1/kbstmn3zvcx9xiutzxso",
          title: item?.user?.username ? item?.user?.username : "-",
          date: `${formattedDate}`,
          mediaLogo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRj-X06O3ppyMhQotOP_Km27fpwe0FgZGqXiA&s",
          content: item.text,
          hashtags: hashtags,
          media: item.media ? item.media.map((m: any) => ({
            url: m.url,
            type: m.type, // photo, video, animated_gif
          })) : [],
        };
      });

      setFeedData(formattedData);
    });
  }, []);

  return (
    <>

      <Grid
        container
        spacing={2}
        sx={{
          // pt: isMobile ? 0 : 2,
          backgroundColor: isMobile ? null : "white",
          height: resolvedHeight,
          margin: "1px",
          borderRadius: "10px",
          width: "100% !important",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* {!isMobile && (
        <Grid item xs={12}>
        </Grid>
      )} */}
        <Grid item xs={12} sx={{ flex: 1, minHeight: 0, overflowY: "auto", px: 2 }} className='scrollbar-cusgray'>
          <Box
          // sx={{
          //   position: "sticky",
          //   top: 0,
          //   zIndex: 1,
          //   backgroundColor: "white",
          //   pt: 1,
          //   pb: 2,
          //   borderBottom: "1px solid #E6E6E8",
          // }}
          >
            {
              !isMobile && <Typography sx={{ fontWeight: 500, textAlign: "left" }} mb={1}>
                My Feed
              </Typography>
            }

          </Box>
          {/* Spotlight section */}

          <Box sx={{ border: "1px solid #E6E6E8", borderRadius: "10px", fontSize: 14, mb: 2, background: KenColors?.ClientPrimary, p: 2 }}>
            <Typography sx={{ fontWeight: 500, color: "#5B4200", textAlign: "left" }}>In the Spotlight</Typography>
            <Box sx={{ mt: 2 }}>
              <iframe
                width="100%"
                height="220"
                src={youtubeVideoURL?.youtube_Video_URL__c ? youtubeVideoURL?.youtube_Video_URL__c : ""}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                style={{ borderRadius: "10px" }}
              ></iframe>
            </Box>
            <Typography sx={{ fontWeight: 500, color: "#5B4200", mt: 2, textAlign: "left" }}>{youtubeVideoURL?.youtube_Title__c}</Typography>
            <Typography sx={{ color: "#5B4200", textAlign: "left" }}>
              {youtubeVideoURL?.youtube_Description__c}
            </Typography>
          </Box>

          {/* Feed items */}
          {feedData.map((item, index) => (
            <Box
              key={index}
              sx={{
                border: "1px solid #E6E6E8",
                borderRadius: "10px",
                mb: 2, fontSize: 14,
                backgroundColor: "white",
                p: 2,
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Box sx={{ flex: '0 0 auto' }}>
                  <img src={item.userImage} alt="User" style={{ width: isMobile ? "30px" : "50px", height: isMobile ? "30px" : "50px", borderRadius: "50%" }} />
                </Box>
                <Box sx={{ flex: 1, minWidth: 0, textAlign: 'left' }}>
                  <Typography sx={{ fontWeight: 500 }} noWrap>
                    {item.title}
                  </Typography>
                  <Typography sx={{ fontSize: 12, color: "gray", textAlign: "left" }}>
                    {item.date}
                  </Typography>
                </Box>
                <Box sx={{ flex: '0 0 auto' }}>
                  <img src={item.mediaLogo} alt="Media" style={{ width: isMobile ? "30px" : "35px", height: isMobile ? "30px" : "35px", borderRadius: "50%" }} />
                </Box>
              </Box>
              <Typography
                mt={3}
                component="div"
                textAlign={"left"}
                dangerouslySetInnerHTML={{ __html: linkify(item.content) }}
              />
              {item.hashtags && (
                <Typography mt={2} textAlign={"left"} color="primary.main" fontSize={14}>
                  {item.hashtags}
                </Typography>
              )}
              {/* Media section */}
              {item.media.length > 0 && (
                <Box mt={2} sx={{ display: 'flex', overflowX: 'auto', gap: 2 }}>
                  {item.media.map((mediaItem, idx) => (
                    <Box key={idx} sx={{ minWidth: "100%", borderRadius: "10px", overflow: "hidden" }}>
                      {mediaItem.type === "photo" && (
                        <img
                          src={mediaItem.url}
                          alt={`media-${idx}`}
                          style={{
                            width: "100%",
                            height: "400px",
                            objectFit: "cover",
                            borderRadius: "10px",
                          }}
                        />
                      )}

                      {mediaItem.type === "video" && (
                        <video
                          src={mediaItem.url}
                          autoPlay
                          controls
                          style={{
                            width: "100%",
                            height: "400px",
                            objectFit: "cover",
                            borderRadius: "10px",
                          }}
                        />
                      )}

                      {mediaItem.type === "animated_gif" && (
                        <video
                          src={mediaItem.url}
                          autoPlay
                          loop
                          muted
                          playsInline
                          style={{
                            width: "100%",
                            height: "400px",
                            objectFit: "cover",
                            borderRadius: "10px",
                          }}
                        />
                      )}
                    </Box>
                  ))}
                </Box>
              )}
            </Box>
          ))}
        </Grid>
      </Grid>
    </>
  );
};

export default Feed;
